<template>
  <div class="search-results-section">
    <div class="recents-heading">
      <!-- .recents-icon-wrap -->
      <img src="../../../assets/img/clock.svg" alt />
      <span>Búsquedas recientes</span>
    </div>

    <ul v-if="history.length > 0" class="search-results-items">
      <li
        v-for="student in history"
        :id="`liStudentSearchResult-${student.studentId}`"
        :key="student.studentId"
        class="search-result-item"
        @click="onStudentSearchClick(student)"
      >
        <span>{{ student.studentId }} - {{ student.fullName }}</span>
        <span class="search-history-impediment-title">
          -
          {{
            student.impediment != '' && student.impediment != null
              ? student.impediment
              : 'No disponible'
          }}
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
// services
import loading from '@/mixin/loading.mixin';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';

import StudentStatuses from '@/utils/constants/student/studentStatuses';

export default {
  name: 'History',
  mixins: [loading, mixAlert],
  data() {
    return {
      studentList: [],
    };
  },
  mounted() {
    this.getHistorySearch();
  },
  computed: {
    history() {
      return this.studentList.slice().reverse();
    },
  },
  methods: {
    getHistorySearch() {
      let historyStudents = [
        ...store.getters['$_student/getSearchedStudentHistory'],
      ];
      this.studentList = historyStudents;
    },
    setLoading(isLoading) {
      this.$emit('on-loading', isLoading);
    },
    onStudentSearchClick(student) {
      let selectedStudentMustHaveRegistration =
        store.getters.SelectedStudentMustHaveRegistration;
      let canSelect =
        !selectedStudentMustHaveRegistration ||
        (selectedStudentMustHaveRegistration &&
          student.statusId != null &&
          student.statusId != StudentStatuses.Disponible);

      if (canSelect) {
        this.$emit('select-student', student);
      } else {
        this.ShowToast(
          'Alerta',
          'El estudiante no cuenta con un registro para el programa de Educación Especial.',
          'error'
        );
      }
    },
  },
};
</script>
